export default __webpack_public_path__ + "static/media/menu.8d4309e5.svg";